import { Pipe, PipeTransform } from '@angular/core';
import { I18NextService } from 'angular-i18next';

@Pipe({
    name: 'i18nextWithLocale',
})
export class I18NextWithLocalePipe implements PipeTransform {
    constructor(private readonly i18n: I18NextService) {}

    transform(key: string, locale: string): string {
        return this.i18n.t(key, { lng: locale }) as string;
    }
}
